<template>
    <div v-if="album" class="actionbar">
        <tags :is-more-photos-section="isMorePhotosSection"/>
        <sorting v-if="+album.show_sorting" :is-more-photos-section="isMorePhotosSection"/>
    </div>
</template>

<style lang="scss">
    .actionbar {
        display: flex;
        justify-content: space-between;
        margin-bottom: 30px;
    }
</style>

<script>
  import Tags from './Tags.vue';
  import Sorting from './Sorting.vue';

  import actionbar from 'src/mixins/actionbarComponent';

  export default {
    mixins: [actionbar],
    components: {
      Tags,
      Sorting,
    },
  };
</script>
